import { AutoComplete, Avatar, Button, Form, Input, Select, Spin } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import moment from "moment";
import { debounce } from "lodash";

const FeedbackList = () => {
  const fetchRef = useRef(null);
  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [baseOrderId, setBaseOrderId] = useState<any>();

  const [FeedbackData, setFeedbackData] = useState({
    loading: false,
    data: null,
  });

  const [orderOptions, setOrderOptions] = useState({
    list: [],
    loading: false,
  });

  const getFeedback = useCallback(async () => {
    setFeedbackData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/feedback/admin/all?page=${page || 0}&limit=${
          limit || 16
        }` +
          (status ? `?status=${status}` : ``) +
          (baseOrderId ? `&orderId=${baseOrderId}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setFeedbackData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setFeedbackData({ loading: false, data: [] });
        console.error("Feedback Type: Error", err);
      });
  }, [page, limit, status, baseOrderId]);

  const getOrderOptions = useCallback(
    async (getOrderId) => {
      setOrderOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
      return axios
        .get(
          `${encodedUri}/admin/order?` +
            (getOrderId
              ? `baseOrderId=${getOrderId}`
              : `` + getOrderId
              ? `orderId=${getOrderId}`
              : ``) +
            `&page=${page || 0}` +
            (type ? `&type=${type}` : ``) +
            (status ? `&status=${status}` : ``) +
            (limit ? `&limit=${limit}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setOrderOptions({
            loading: false,
            list: res.data?.orders?.map((order, index) => ({
              key: index,
              label: order.baseOrderId,
              value: order.baseOrderId,
            })),
          });
        })
        .catch((err) => {
          setOrderOptions({ loading: false, list: [] });
          console.error("Categories: Error", err);
        });
    },
    [limit, page, status, type]
  );

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "order") getOrderOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getOrderOptions]);

  useEffect(() => {
    getFeedback();
  }, [getFeedback]);

  const reseAllFieldData = () => {
    setStatus("");
    setType("JC_MART");
    setBaseOrderId("");
    form.resetFields();
  };

  return (
    <React.Fragment>
      <TopHeading
        {...FeedbackData?.data?.totalElements}
        refetch={getFeedback}
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="baseOrderIdSearch" initialValue={baseOrderId}>
            <AutoComplete
              dropdownMatchSelectWidth={250}
              style={{ width: 250 }}
              onSearch={(e) => handleSearch(e, "order")}
              onSelect={(val) => {
                setBaseOrderId(val);
              }}
              options={orderOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                orderOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                size="large"
                placeholder="Base Order ID"
                onSearch={(val) => {
                  setBaseOrderId(val);
                }}
                enterButton
              />
            </AutoComplete>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>User</span>
                  </div>
                  <div className="single-product-heading">
                    <span>User Contact</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Date & Time</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Order ID</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {FeedbackData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {FeedbackData?.data?.feedbacks?.length ? (
                    FeedbackData?.data?.feedbacks?.map(
                      (feedback: any, index: any) => (
                        <React.Fragment key={index}>
                          <Link to={`/feedback/${feedback?.id}/details`}>
                            <div className="single-product-wrapper">
                              <div className="single-product">
                                <span className="name">
                                  <Avatar
                                    src={feedback?.profilePicture}
                                    className="mr-2"
                                  />
                                  {feedback?.customer?.name}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  {feedback?.customer?.mobileNumber?.split(
                                    "+88"
                                  )}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  <small
                                    className={`text-capitalize ${
                                      moment().diff(
                                        feedback?.createdAt,
                                        "minutes"
                                      ) >= 60
                                        ? "font-weight-bold text-danger"
                                        : "text-dark"
                                    }`}
                                  >
                                    {moment(feedback?.createdAt).fromNow()}
                                  </small>{" "}
                                  <br />
                                  {moment(feedback?.createdAt).format("lll")}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  {feedback?.orderId}
                                </span>
                              </div>
                              <div className="single-product">
                                <span
                                  className={`radius-btn ${feedback?.status?.toLowerCase()}-btn`}
                                >
                                  {feedback?.status}
                                </span>
                              </div>
                            </div>
                          </Link>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Feedbacks" />
                  )}
                </div>
              </div>
            )}
          </div>

          <PaginationTwo
            {...FeedbackData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FeedbackList;
